import { render } from "./TableB.vue?vue&type=template&id=31556bef&scoped=true"
import script from "./TableB.vue?vue&type=script&lang=ts"
export * from "./TableB.vue?vue&type=script&lang=ts"

import "./TableB.vue?vue&type=style&index=0&id=31556bef&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-31556bef"

export default script